import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-weedex-table',
  templateUrl: './weedex-table.component.html',
  styleUrls: ['./weedex-table.component.css']
})
export class WeedexTableComponent {

  tableData;
  weedexData;
  weedexItemOver;
  lastClickedWord: any;
  currentItemType: any;
  currentItem: any;
  lastTarget: any;
  origWeedexData: any;


  ngAfterViewInit() {
  }

  displayTable(body: any) {
    this.weedexData = body;
    let color = 'black';

    this.tableData = body.result;

  }

  unchooseTr() {
    if (!this.tableData) return;
    for (let item of this.tableData) {
      item.chosen = false;
    }
  }



  itemFocusout() {

  }

  tableItemDown($event, type, item) {
    console.log($event);

    $event.currentTarget.style.backgroundColor = 'yellow';
    if (this.lastTarget && this.lastTarget != $event.currentTarget) {
      this.lastTarget.style.backgroundColor = 'white';
    }
    this.lastTarget = $event.currentTarget;
    this.currentItemType = item[type];
    this.currentItem = item;


  }

  wordClicked(word: any) {
    if (this.lastClickedWord == word) return;
    // console.log(word["description"]);
    this.lastClickedWord = word;
    setTimeout(() => {
      this.lastClickedWord = null;
    }, 1000);
    if (this.currentItemType) {
      this.currentItemType.word.text += ` ${word['description']}`;
    }
  }
  addRow() {
    this.tableData.unshift({
      label: { word: { text: '' } },
      value: { word: { text: '' } },
      chosen: true,
    });
  }
  restart() {
    this.unchooseTr();
    this.tableData = null;
  }
}
